<template>
  <div v-show="isLanguageViewActiveLocal">
    <div v-if="!isTeacher && !isStudent" class="limit-width_fixed-scalable mb-3" style="text-align: left;">
      <span style="display: inline-flex" class="mt-6">
        <img id="profileimg" :src="profilePic" width="25%">
        <div>
          <p style="font-size: 16pt;color:white;" class="ml-4 mt-3">Hi {{ user_displayName.split(' ')[0] }},</p>
          <p style="font-size: 11pt;color:white;" class="ml-4">Welcome back!</p></div>
      </span>
    </div>

    <ul style="margin-top: 3px;flex-wrap: wrap;">
      <div class="limit-width_fixed-scalable" style="text-align: left;">
        <li>
          <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 277px">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_bg-color__blend bg-color">
                  <span><feather-icon class="pt-1" icon="MessageCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button :disabled="true"
                         size="large"
                         class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
                         type="filled"
                         color="">
                Select a Language
              </vs-button>
            </vx-input-group>
          </vx-card>
        </li>
      </div>
      <li v-for="(_language, langIndex) in languages" :key="langIndex" class="mb-4">
        <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="MessageCircleIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                       class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                       style="border-radius:0 7px 7px 0;"
                       @click="selectLanguage(_language)">
              {{ _language }}
            </vs-button>
          </vx-input-group>
        </vx-card>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    isLanguageViewActive: {
      required: false,
    },
    isStudent: {
      type: Boolean,
      required: false
    },
    languages: {
      type: Array,
      required: false
    },
    isTeacher: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    isLanguageViewActiveLocal: {
      get() {
        return this.isLanguageViewActive;
      }
    },
    user_displayName() {
      return JSON.parse(localStorage.getItem("userInfo")).displayName != null
        ? JSON.parse(localStorage.getItem("userInfo")).displayName.split("(")[0]
        : JSON.parse(localStorage.getItem("userInfo")).displayName;
    },
    profilePic() {
      return localStorage.getItem("pictureUrl") == null ||
        localStorage.getItem("pictureUrl") == "null" ||
        localStorage.getItem("pictureUrl") == "" ||
        localStorage.getItem("pictureUrl") == "undefined"
        ? "https://forty5degreesstorage.blob.core.windows.net/user/avatar_default.png"
        : localStorage.getItem("pictureUrl");
    }
  },
  methods: {
    selectLanguage(language) {
      var self = this;
      self.$emit("languageSelected", language);
    }
  }
};
</script>
